import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers/root";
import { BaseAsyncReducerState } from "../../../redux/types";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import PierTutorial from "../PierTutorial/PierTutorial";
import RegUserForm from "./RegUserForm";
import addSuperScript from "../../../utils/superscript";

export default function RegUser(): JSX.Element {

    const { t } = useTranslation('login');

    const loginResult = useSelector((state: RootState) => state.authReducer.login as BaseAsyncReducerState)

    return (
        <div className="login-container-row">
            <div className="login-container">
                <div className="dark-blue-background">
                    {addSuperScript(t('reg-user-prompt') as string)}
                </div>
                <AmpLoadingSpinner loading={loginResult.loading}>
                    <div className="login-container-content">
                        <RegUserForm />
                    </div>
                </AmpLoadingSpinner>
            </div>
            {/* <img alt="" className="img-side" src="./images/ea_background-no-bg.png"/> */}
            <PierTutorial />
        </div>
    )
}